<template>
  <div class="h-full flex flex-col gap-3 lg:gap-5 items-center justify-center">
    <!-- Container With BG Image -->
    <div
      class="relative w-full h-full bg-cover bg-center bg-no-repeat rounded-3xl px-6 pt-6 border border-outline-dividers flex flex-col min-h-0"
      :style="{ backgroundImage: `url(${bgImg})` }"
    >
      <!-- Opacity Insert -->
      <div class="absolute inset-0 bg-primary-6 opacity-80 rounded-3xl z-0"></div>
      <!-- Content Container -->
      <div class="relative z-10 w-full flex-1 flex flex-col items-start min-h-0">
        <!-- Top Logo -->
        <img :src="phxLogo" alt="" class="h-10 lg:h-12 object-contain shrink-0" />
        <!-- Take Flight -->
        <div
          class="text-grey-1 text-[32px] lg:text-5xl font-medium lg:font-semibold mt-[32px] lg:mt-[49px] mb-4 lg:mb-[38px] shrink-0"
        >
          <h3>Take Flight</h3>
          <h3 class="-mt-4 lg:-mt-0">with Phoenix</h3>
        </div>

        <h4 class="text-grey-1 text-xl lg:text-[28px] font-semibold mb-5 shrink-0">
          Join 6,900+ Investors*
        </h4>
        <!-- This is the key change: flex-1 + min-h-0 + overflow-y-auto -->
        <div class="flex-1 min-h-0 w-full overflow-y-auto no-scrollbar pb-6">
          <div class="flex flex-col gap-3">
            <div
              v-for="review in investorReviews"
              class="rounded-xl text-sm font-medium bg-container-bg-dis-canvas p-4 flex flex-col gap-4 text-strongest"
            >
              <p class="font-inter">"{{ review.review }}"</p>
              <div class="flex items-center gap-4">
                <img :src="review.img" alt="" class="h-10 w-10 object-cover rounded-full" />
                <p class="font-medium font-inter">{{ review.name }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Disclaimer at bottom -->
    <div class="text-xxs text-light font-medium shrink-0 mx-2 lg:mx-0">
      <p class="font-inter">* Investor count is from Inception to 03.09.2026</p>
      <p class="font-inter">
        Note: The testimonials may not be representative of other investors not listed on this page.
        The testimonials are no guarantee of future performance or success of the company or a
        return on investment.
      </p>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";

import phxLogo from "@/assets/images/PHX_ENERGY_WHITE_TEXT.png";
import bgImg from "@/assets/images/admin_bg_small.png";
import testimonial_img_1 from "@/assets/images/JeffP_Testimonial.png";
import testimonial_img_2 from "@/assets/images/Karen_Testimonial.png";
import testimonial_img_3 from "@/assets/images/Branden_Testimonial.png";

const activeReviewIndex = ref(0);
const investorReviews = ref([
  {
    index: 1,
    name: "Jeff P.",
    img: testimonial_img_1,
    review:
      "I was intrigued by the attractive yields Phoenix Capital Group offered. After Matt explained how the Company operates…I was more excited. While I typically focus on equity investments, this offers attractive yield in a low-yield market.",
  },
  {
    index: 2,
    name: "Karen W.",
    img: testimonial_img_2,
    review:
      "My dealings with Phoenix Capital Group have been professional yet simple and straightforward. My questions have been answered quickly by their knowledgeable staff.",
  },
  {
    index: 3,
    name: "Brandon F.",
    img: testimonial_img_3,
    review:
      "The Phoenix investment opportunity was brought to me by Matt, who I have known for a while. I was excited to see that I could get above-market yield…that generated good income-producing returns. It’s a great investment for us.",
  },
]);

let interval = null;
onMounted(() => {
  if (interval) clearInterval(interval);
  interval = setInterval(() => {
    activeReviewIndex.value = activeReviewIndex.value === 2 ? 0 : activeReviewIndex.value + 1;
  }, 9000);
});
</script>

<style scoped>
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition:
    opacity 0.5s,
    transform 0.5s;
}
.fade-slide-enter-from,
.fade-slide-leave-to {
  opacity: 0;
  transform: translateX(100px);
}
.fade-slide-enter-to,
.fade-slide-leave-from {
  opacity: 1;
  transform: translateX(0);
}
</style>
